<template>
    <div class="s-bg">
      <van-nav-bar
        title="创建成功"
        left-arrow
        fixed
        placeholder
        @click-left="onClickLeft">
      </van-nav-bar>
      <div class="s-header">
        <img src="../../../assets/img/success.png"/>
        <h3>完成创建 <small>恭喜您，简历创造成功</small> </h3>
      </div>
      <div class="btn-group">
        <van-button class="org" color="linear-gradient(to right, #F69B58, #F87342)" round>
          继续完善简历
        </van-button>
        <van-button class="blue" color="linear-gradient(to right, #2F72F6, #1C54CF)" round>
          查看职位
        </van-button>
      </div>
    </div>
</template>

<script>
    export default {
        name: "success"
    }
</script>

<style lang="less" scoped>
  .s-bg{
    background: url("../../../assets/img/s-bg.png") no-repeat;
    background-size: 100% 230px;
  }
  /deep/.van-nav-bar{
    background:none;
    color:#fff;
    border-bottom: 0;
    .van-nav-bar__title{
      color:#fff;
    }
    .van-icon{
      color:#fff;
    }
  }
  .s-header{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 150px;
    img{
      width: 64px;
      height: 64px;
      margin-right: 20px;
    }
    h3{
      font-size: 20px;
      color:#fff;
      font-weight: bold;
      small{
        font-size: 14px;
        display: block;
        margin-top: 4px;
        font-weight: normal;
      }
    }
  }
  .btn-group{
    display: flex;
    flex-direction: column;
    margin-top: 76px;
    align-items: center;
    button{
      margin-bottom: 20px;
      height: 38px;
      min-width: 185px;
      &.blue{
        box-shadow: 0 0 10px rgba(60, 125, 255, 0.48);
      }
      &.org{
        box-shadow: 0 0 10px rgba(255, 172, 99, 0.4);
      }
    }
  }

</style>
